import api from './api';

export async function getDeveloperProfile() {
  const { data } = await api.get('/agents/developer/profile');
  return data;
}

export async function saveDeveloperProfile(payload: any) {
  const { data } = await api.post('/agents/developer/profile', payload);
  return data;
}

export async function listDeveloperAgents() {
  const { data } = await api.get('/agents/developer/my-agents');
  return data?.items || [];
}

export async function createDeveloperAgent(payload: any) {
  const { data } = await api.post('/agents/developer/agents', payload);
  return data;
}

export async function validateAgentManifest(agentCode: string, manifest: any) {
  const { data } = await api.post(`/agents/developer/agents/${agentCode}/validate-manifest`, { manifest });
  return data;
}

export async function runAgentSandbox(agentCode: string, input: string) {
  const { data } = await api.post(`/agents/developer/agents/${agentCode}/sandbox-runs`, { input });
  return data;
}

export async function submitAgentReview(agentCode: string) {
  const { data } = await api.post(`/agents/developer/agents/${agentCode}/submit-review`, {});
  return data;
}

export async function testAgentConnectivity(serviceBaseUrl: string) {
  const { data } = await api.post('/agents/developer/test-connectivity', { serviceBaseUrl });
  return data;
}

export async function listAgentReviews() {
  const { data } = await api.get('/agents/admin/reviews');
  return data?.items || [];
}

export async function decideAgentReview(reviewId: string, action: string, message?: string) {
  const { data } = await api.post(`/agents/admin/reviews/${reviewId}/decision`, { action, message });
  return data;
}
